import { objectToGetParams } from "@utils/link";
import { TwitterService } from "./twitterService";

export class BrowserTwitterService implements TwitterService {
	async openShareDialog(url: string, text: string): Promise<void> {
		return new Promise(function () {
			window.open("https://twitter.com/intent/tweet" + objectToGetParams({ url, text }));
			// window.open('http://twitter.com/share?url='+encodeURIComponent(url)+'&text='+encodeURIComponent(text), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
		});
	}
}
